<div class="mt-2 action-bar-container-md"
  style="display: flex; justify-content: space-between; border: 1px solid lightgray; border-radius: 10px; padding: 10px;">
  <div>
    @if (backLabel) {
      <p-button icon="pi pi-chevron-left left-arrow" [label]="backLabel" [link]="true"
        styleClass="outline-none font-italic text-lg pl-0 mr-8 pr-8" (onClick)="navigateBack()"
      ></p-button>
    }
  </div>
  <button [label]="label" rounded="true" pButton pRipple [disabled]="disabled" (click)="onSave()" size="small">
  </button>
</div>

<div class="flex flex-column gap-3 mt-3 action-bar-container-sm">
  <div class="flex w-full">
    @if (label) {
      <button [label]="label" [disabled]="disabled" pButton pRipple class="w-full py-2"
        (click)="onSave()" size="small">
      </button>
    }
  </div>
  @if (backLabel) {
    <div class="flex justify-content-center">
      <p-button [label]="backLabel" [link]="true" styleClass="outline-none font-italic text-lg"
      (onClick)="navigateBack()"></p-button>
    </div>
  }
</div>